import dayjs from 'dayjs';

const calendarTypes = ['google', 'default'];

const buttonTypes = {
  google: event => {
    let calendarUrl = '';
    calendarUrl = 'https://calendar.google.com/calendar/render';
    calendarUrl += '?action=TEMPLATE';
    calendarUrl += '&dates=' + event.startTime;
    calendarUrl += '/' + event.endTime;
    calendarUrl += '&location=' + encodeURIComponent(event.location);
    calendarUrl += '&text=' + encodeURIComponent(event.title);
    calendarUrl += '&details=' + encodeURIComponent(event.description);

    return calendarUrl;
  },
  default: event => {
    let calendarUrl = '';
    calendarUrl = [
      'BEGIN:VCALENDAR',
      'VERSION:2.0',
      'BEGIN:VEVENT',
      'URL:' + event.url,
      'DTSTART:' + event.startTime,
      'DTEND:' + event.endTime,
      'SUMMARY:' + event.title,
      'DESCRIPTION:' + event.description,
      'LOCATION:' + event.location,
      'END:VEVENT',
      'END:VCALENDAR',
    ].join('\n');

    return calendarUrl;
  },
};

const generateCalendarButtonURL = (event, type, isIE = false) => {
  const bookingLink = location.protocol + '//' + location.host + location.pathname;
  const properEvent = {
    title: event.title,
    description: event.description,
    location: event.location,
    url: event.url || bookingLink,
    startTime: dayjs(event.startTime).utc().format('YYYYMMDDTHHmmss'),
    endTime: dayjs(event.endTime).utc().format('YYYYMMDDTHHmmss'),
  };

  const prefix = isIE ? 'data:text/calendar;charset=utf8,' : '';
  const generatorFunction = calendarTypes.includes(type) ? buttonTypes[type] : buttonTypes.default;

  return prefix + generatorFunction(properEvent);
};

export default generateCalendarButtonURL;
